// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { BiometricApi } from '../types/biometric.types';
import { biometricHttpApi } from './biometric.api';
import { biometricMockApi } from './biometric.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const biometricApi: BiometricApi = useMock
  ? biometricMockApi
  : biometricHttpApi;
